exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-741e9945] .el-tabs__content{height:calc(100% - 50px)}[data-v-741e9945] .el-tabs__content .el-tab-pane{overflow-y:auto;height:100%}", ""]);

// exports
